module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.name),
      expression: "tryout.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Judul Tryout"
    },
    domProps: {
      "value": (_vm.tryout.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.description),
      expression: "tryout.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "description",
      "placeholder": "Deskripsi Tryout"
    },
    domProps: {
      "value": (_vm.tryout.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tryout Instan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.is_repeated),
      expression: "tryout.is_repeated"
    }],
    attrs: {
      "type": "checkbox",
      "value": "is_repeated"
    },
    domProps: {
      "checked": Array.isArray(_vm.tryout.is_repeated) ? _vm._i(_vm.tryout.is_repeated, "is_repeated") > -1 : (_vm.tryout.is_repeated)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tryout.is_repeated,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "is_repeated",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tryout, "is_repeated", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tryout, "is_repeated", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tryout, "is_repeated", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.level),
      expression: "tryout.level"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "level"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.selectingLevel()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "SMA"
    }
  }, [_vm._v("SMA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SMP"
    }
  }, [_vm._v("SMP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("SD")])])])]), _vm._v(" "), (_vm.tryout.is_repeated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout_grade),
      expression: "tryout_grade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "level"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tryout_grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.gradeList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenis *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.type),
      expression: "tryout.type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SNBT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("Ujian Nasional (UN)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("Ujian Akhir Sekolah (UAS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("Ujian Sekolah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PENILAIAN_TENGAH_SEMESTER"
    }
  }, [_vm._v("Penilaian Tengah Semester (PTS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PENILAIAN_AKHIR_SEMESTER"
    }
  }, [_vm._v("Penilaian Akhir Semester (PAS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_MANDIRI"
    }
  }, [_vm._v("Ujian Mandiri (UM)")])])])]), _vm._v(" "), (_vm.tryout.type == 'SBMPTN' && _vm.tryout.level == 'SMA') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kategori *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.category),
      expression: "tryout.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "TPS"
    }
  }, [_vm._v("TPS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LITERASI"
    }
  }, [_vm._v("LITERASI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("SAINTEK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("SOSHUM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TKPA"
    }
  }, [_vm._v("TKPA (Sudah Tidak Berlaku)")])])])]) : (_vm.tryout.type != 'SBMPTN' && _vm.tryout.level == 'SMA') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kategori *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.category),
      expression: "tryout.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("SAINTEK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("SOSHUM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kategori *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.category),
      expression: "tryout.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi (Menit) *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.duration),
      expression: "tryout.duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "name"
    },
    domProps: {
      "value": (_vm.tryout.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "duration", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.start_date),
      expression: "tryout.start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.start_time),
      expression: "tryout.start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "start_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.end_date),
      expression: "tryout.end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "end_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.end_time),
      expression: "tryout.end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "end_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Selanjutnya")])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5310890c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryout/TryoutForm.vue
// module id = 1341
// module chunks = 0